<template>
  <div class="dtablerow">

    <!-- Left Panel -->
    <aside id="left-panel" class="left-panel">
      <LeftMenu/>
    </aside><!-- /#left-panel -->
    <!-- Left Panel -->

    <!-- Right Panel -->
    <div id="right-panel" class="right-panel">
      <!-- Header-->
      <header id="header" class="header">
        <div class="header-menu">
          <div class="col-sm-7">
            <MenuToggle/>
            <div class="header-left">
              <HeaderSearch/>
              <HeaderCompanySelector/>
              <HeaderNotification/>
              <HeaderMessages/>
            </div>
          </div>
          <div class="col-sm-5">
            <User/>
            <LngChooser/>
          </div>
        </div>
      </header><!-- /header -->
      <!-- Header-->
      <Breadcrumbs :breadcrumbstitle="breadcrumbstitle" :breadcrumbsData="breadcrumbsData"/>
      <div class="content mt-3">
        <div class="animated fadeIn fContainer" v-if="this.hasRole">
          <!-- content place -->


          <div class="col-lg-12 fColumn">
            <div class="card fColumn">
              <div class="card-header">
                <strong>{{$t('BusinessPartner.title')}}</strong>
                <div class="float-right">
                  <router-link :to="{ path: '/businesspartners'}" class="btn btn-link btn-sm"><i class="fa fa-link"></i> {{$t('BusinessPartners.title')}}</router-link>
                  &nbsp;
                  <span class="btn btn-primary btn-sm" v-on:click="emptyForNew()"><i class="fa fa-link"></i> {{$t('BusinessPartner.new')}}</span>
                </div>
              </div>
              <div class="card-body card-block">
                <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
                <!--<AlertInPage />-->
                <!--<AlertInPage type="success" msg="msg" delay="2000"/>-->
                <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">

                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="id" class=" form-control-label">{{$t('BusinessPartner.id')}}</label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<p class="form-control-static"><input v-model="data.id" type="text" id="id" name="text-input" placeholder="" class="form-control" disabled readonly></p>-->
                  <!--</div>-->
                  <!--</div>-->

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="businesspartnername" class=" form-control-label">{{ $t('BusinessPartner.businesspartnername') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.businesspartnername" type="text" id="businesspartnername" placeholder="" class="form-control" name="data.businesspartnername"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.businesspartnername')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="taxnumber" class=" form-control-label">{{ $t('businesspartner.taxnumber') }} </label></div>
                    <div class="col-12 col-md-9">
                      <table class="w100">
                        <tr>
                          <td class="w0 valigntop">
                            <template v-if="hasnav===true">
                              <div class="input-group topminus2px">
                                <div class="btn btn-primary" v-on:click="getQueryTaxpayer()"><i class="fa fa-eye-slash"></i></div>
                              </div>
                            </template>
                          </td>
                          <td class="w100">
                            <InputText
                              id="taxnumber" name="data.taxnumber" v-model="data.taxnumber" v-validate="" hasToKeyboard="auto" value=""
                              :title="$t('businesspartner.taxnumber')"
                              placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.taxnumber')"/>
                            <small class="form-text text-muted"></small>
                          </td>
                        </tr>
                      </table>
                      <DataCheckerErrorDisplayer defaultclass="alert alert-danger" v-if="true" :value="data.taxnumber" :isMandatory="false"
                                                 :displayfn="displayfn_from_taxnumber" messageKey="global.taxnumberformaterror" ></DataCheckerErrorDisplayer>

                    </div>
                  </div>


                  <!--<div class="row form-group">-->
                  <!--<div class="col col-md-3"><label for="taxnumber" class=" form-control-label">{{ $t('BusinessPartner.taxnumber') }} </label></div>-->
                  <!--<div class="col-12 col-md-9">-->
                  <!--<input v-model="data.taxnumber" type="text" id="taxnumber" placeholder="" class="form-control" name="data.taxnumber"-->
                  <!--v-validate="''" v-bind:class="{'is-invalid':errors.has('data.taxnumber')}">-->
                  <!--<small class="form-text text-muted"></small>-->
                  <!--</div>-->
                  <!--</div>-->
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="taxnumbercountrygroup" class=" form-control-label">{{ $t('BusinessPartner.taxnumbercountrygroup') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.taxnumbercountrygroup" type="text" id="taxnumbercountrygroup" placeholder="" class="form-control" name="data.taxnumbercountrygroup"
                             v-validate="" v-bind:class="{'is-invalid':errors.has('data.taxnumbercountrygroup')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="taxnumberother" class=" form-control-label">{{ $t('BusinessPartner.taxnumberother') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.taxnumberother" type="text" id="taxnumberother" placeholder="" class="form-control" name="data.taxnumberother"
                             v-validate="" v-bind:class="{'is-invalid':errors.has('data.taxnumberother')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="registrationnumber" class=" form-control-label">{{ $t('BusinessPartner.registrationnumber') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.registrationnumber" type="text" id="registrationnumber" placeholder="" class="form-control" name="data.registrationnumber"
                             v-validate="" v-bind:class="{'is-invalid':errors.has('data.registrationnumber')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="bank_account" class=" form-control-label">{{ $t('BusinessPartner.bank_account') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.bank_account" type="text" id="bank_account" placeholder="" class="form-control" name="data.bank_account"
                             v-validate="" v-bind:class="{'is-invalid':errors.has('data.bank_account')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="zip" class=" form-control-label">{{ $t('CrmAddress.zip') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.zip" type="text" id="zip" placeholder="" class="form-control" name="data.zip"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.zip')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="public_space" class=" form-control-label">{{ $t('CrmAddress.public_space') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.public_space" type="text" id="public_space" placeholder="" class="form-control" name="data.public_space"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.public_space')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="nature_of_public_space" class=" form-control-label">{{ $t('CrmAddress.nature_of_public_space') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.nature_of_public_space" type="text" id="nature_of_public_space" placeholder="" class="form-control" name="data.nature_of_public_space"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.nature_of_public_space')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="house_number" class=" form-control-label">{{ $t('CrmAddress.house_number') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.house_number" type="text" id="house_number" placeholder="" class="form-control" name="data.house_number"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.house_number')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="building" class=" form-control-label">{{ $t('CrmAddress.building') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.building" type="text" id="building" placeholder="" class="form-control" name="data.building"
                             v-bind:class="{'is-invalid':errors.has('data.building')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="staircase" class=" form-control-label">{{ $t('CrmAddress.staircase') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.staircase" type="text" id="staircase" placeholder="" class="form-control" name="data.staircase"
                             v-bind:class="{'is-invalid':errors.has('data.staircase')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="floor" class=" form-control-label">{{ $t('CrmAddress.floor') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.floor" type="text" id="floor" placeholder="" class="form-control" name="data.floor"
                             v-bind:class="{'is-invalid':errors.has('data.floor')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="door" class=" form-control-label">{{ $t('CrmAddress.door') }}</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.door" type="text" id="door" placeholder="" class="form-control" name="data.door"
                             v-bind:class="{'is-invalid':errors.has('data.door')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="city" class=" form-control-label">{{ $t('CrmAddress.city') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.city" type="text" id="city" placeholder="" class="form-control" name="data.city"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.city')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="county" class=" form-control-label">{{ $t('CrmAddress.county') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.county" type="text" id="county" placeholder="" class="form-control" name="data.county"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.county')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="country" class=" form-control-label">{{ $t('CrmAddress.country') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.country" type="text" id="country" placeholder="" class="form-control" name="data.country"
                             v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.country')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="email_def" class=" form-control-label">{{ $t('BusinessPartner.email_def') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.email_def" type="text" id="email_def" placeholder="" class="form-control" name="data.email_def"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.email_def')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-"><label for="phone_def" class=" form-control-label">{{ $t('BusinessPartner.phone_def') }} </label></div>
                    <div class="col-12 col-md-9">
                      <input v-model="data.phone_def" type="text" id="phone_def" placeholder="" class="form-control" name="data.phone_def"
                             v-validate="''" v-bind:class="{'is-invalid':errors.has('data.phone_def')}">
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-3 extensionLine">
                      <label for="discount" class=" form-control-label">{{$t('BusinessPartner.discount')}}</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <!--required|-->
                      <input v-model="data.discount" type="text" id="discount" placeholder="" class="form-control" name="data.discount"
                             v-validate="'integer|between:0,100'" v-bind:class="{'is-invalid':errors.has('data.discount')}">

                      <!--<InputText id="data.discount"  name="data.discount" v-model="data.discount" v-validate="'integer|between:0,100'" hasToKeyboard="auto" value="" :title="$t('businesspartner.discount')"-->
                      <!--placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.discount')"/>-->
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                </form>
              </div>
              <div class="card-footer">
                <button type="submit" class="btn btn-primary btn-sm" v-on:click="save()">
                  <i class="fa fa-dot-circle-o"></i> {{$t('BusinessPartner.submit')}}
                </button>
                <!--<button type="reset" class="btn btn-danger btn-sm">-->
                <!--<i class="fa fa-ban"></i> Reset-->
                <!--</button>-->
              </div>

              <!--<hr>-->
              <!--<div v-if="Number(data.id)>0">-->
              <!--<div class="card-body card-block fColumn">-->
              <!--<div>-->
              <!--<router-link :to="{ name: 'crmaddressParams', params: { addressType:'businesspartner' ,dataId:data.id}}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('CrmAddress.new')}}</router-link>-->
              <!--</div>-->
              <!--&lt;!&ndash;<router-link :to="{ path: '/crmaddress'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('CrmAddress.new')}}</router-link>&ndash;&gt;-->

              <!--<Addresses addressType="businesspartner" :dataId="data.id"></Addresses>-->
              <!--</div>-->
              <!--<hr>-->
              <!--<div class="card-body card-block fColumn">-->
              <!--<div>-->
              <!--<router-link :to="{ name: 'crmcontactParams', params: { contactType:'businesspartner' ,dataId:data.id}}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('CrmContact.new')}}</router-link>-->
              <!--</div>-->
              <!--&lt;!&ndash;<router-link :to="{ path: '/crmaddress'}" class="btn btn-primary btn-sm"><i class="fa fa-link"></i> {{$t('CrmAddress.new')}}</router-link>&ndash;&gt;-->

              <!--<Contacts contactType="businesspartner" :dataId="data.id"></Contacts>-->
              <!--</div>-->
              <!--</div>-->
            </div>

          </div>


        </div><!-- .animated -->

        <div class="animated fadeIn" v-if="!this.hasRole">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemcheckstitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemchecks')}}</div>
            </div>
          </div>
        </div><!-- .animated -->
        <div class="animated fadeIn" v-if="this.hasRole&&!this.hasCompany">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header">
                <strong>{{$t('global.roleproblemnocompanytitle')}}</strong>
                <div class="float-right">
                </div>
              </div>
              <div class="card-body card-block">{{$t('global.roleproblemnocompany')}}</div>
            </div>
          </div>
        </div><!-- .animated -->

      </div><!-- .content -->
    </div><!-- /#right-panel -->
    <!-- Right Panel -->
  </div>

</template>

<script>

  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderCompanySelector from '@/components/HeaderCompanySelector.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import BarcodeGenerator from '@/components/BarcodeGenerator.vue';
  import JsBarcode from 'jsbarcode';
  import MenuToggle from '@/components/MenuToggle.vue';
  import InputText from '@/components/InputText.vue';
  //  import Addresses from '@/components/Addresses.vue';
  //  import Contacts from '@/components/Contacts.vue';
  import HelperRole from '@/helper/HelperRole';
  import DataCheckerErrorDisplayer from '@/components/DataCheckerErrorDisplayer.vue';

  export default {
    name: 'BusinessPartner',
    data() {
      return {
//        moduleRights: []
//        , moduleRightsIds: []
//        , roles: []
//        , user_role: 0
//        ,
        Helper: Helper
        ,
        data: {
          "id": "",
          "businesspartnername": "",
//          "dt": "",
          "taxnumber": "",
          "taxnumbercountrygroup": "",
          "taxnumberother": "",
          "registrationnumber": "",
          "bank_account": "",
          "zip": "",
          "public_space": "",
          "nature_of_public_space": "",
          "house_number": "",
          "building": "",
          "staircase": "",
          "floor": "",
          "door": "",
          "county": "",
          "city": "",
          "country": "",
          "email_def": "",
          "phone_def": "",
          "discount": "",
        }
        , dataBase: { // need for change without save
          "id": "",
          "businesspartnername": "",
//          "dt": "",
          "taxnumber": "",
          "taxnumbercountrygroup": "",
          "taxnumberother": "",
          "registrationnumber": "",
          "bank_account": "",
          "zip": "",
          "public_space": "",
          "nature_of_public_space": "",
          "house_number": "",
          "building": "",
          "staircase": "",
          "floor": "",
          "door": "",
          "county": "",
          "city": "",
          "country": "",
          "email_def": "",
          "phone_def": "",
          "discount": "",
        }
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        }
        , breadcrumbstitle: 'BusinessPartner.title'
        , breadcrumbsData: [
          {
            'title': "BusinessPartners.title",
            'url': "BusinessPartners",
          },
          {
            'title': "BusinessPartner.title",
          }
        ]
        , barcode: ""
        , HelperRole: HelperRole
        , hasRole: false
        , hasCompany: false
        , state: {}
        , stateHash: ""

        , hasnav: false

      };
    },
    props: {
      id: String,
    },
    watch: {
      "$store.state.healthCheckHash": function (newData, oldData) {
        const modul = this;
        if (newData !== oldData) {
          modul.state = Object.assign({}, modul.$store.state);
          modul.handleRights();
          this.getElement();
        }
      },
      'hasRole': function (newVal, oldVal) {
        const modul = this;
        if (newVal && !oldVal) {
          if (modul.hasRole && modul.hasCompany) {
            modul.init();
          }
        }
      },

      '$route.params': function (newdata, olddata) {
        if (this.$route.params.id) {
          this.id = newdata;
          this.getElement();
        } else {
          this.id = void 0;
        }
      }
    },
    mounted() {
      const modul = this;
      modul.handleRights();
    },
    methods: {
      handleRights(){
        const modul = this;
        modul.state = Object.assign({}, modul.$store.state);
        if (HelperRole.hasRights(modul.state, [14], [16,20])) {
          modul.hasRole = true;
        }
        if (modul.state.id_company) {
          modul.hasCompany = true;
        }
        if (modul.hasRole && modul.hasCompany) {
//          modul.init();
        }
        if (modul.state && modul.state.settings) {
          modul.hasnav = (modul.state.settings.hasnav === "true");
        }
      },
      init(){
        const modul = this;
        modul.getElement();
      },
      emptyForNew(){
        this.data = Object.assign({}, this.dataBase);
        this.$router.push({name: "/businesspartner"})
      },
      getElement(){
        const modul = this;
        let id = 0;
        try {
          id = this.$route.params.id;
          if (id) {
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.getBusinessPartner({id: id, id_company: modul.state.id_company}).then(function (res) {
              console.log(res);
              if (res && res.result) {
                modul.data = res.data;
                  modul.AlertInPage.msg = "";
              } else {
                modul.hasRole = false;
                modul.AlertInPage.msg = "form.roles_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                  modul.$router.push({path: "/businesspartners"})
                }, Number(2000));

              }
            }, function (e) {
              modul.AlertInPage.msg = "form.error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });
          }
        } catch (e) {
          console.log(e);
        }
      },
      emptyForNew(){
        this.data = Object.assign({}, this.dataBase);
//        this.$router.push({name: "crmbusinesspartner"})
      },
      save(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
          if (result) {
            const req = {};
            req.data = Helper.makeFilteredObjectByKeys(modul.data, ["id", "businesspartnername", "taxnumber", "taxnumbercountrygroup", "taxnumberother", "registrationnumber", "bank_account", "zip", "public_space", "nature_of_public_space", "house_number", "building", "staircase", "floor", "door", "county", "city", "country", "email_def", "phone_def", "discount"]);
            req.id_company = modul.state.id_company;

            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.saveBusinessPartner(req).then(function (res) {
              if (res && res.result) {
                if (res && res.data.id) {
                  modul.data.id = res.data.id;
                }
                modul.AlertInPage.msg = "form.save_succes";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              } else {
                modul.AlertInPage.msg = "form.save_error";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(modul.AlertInPage.delay));
              }
            }, function (e) {
              modul.AlertInPage.msg = "form.save_error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
          }
        });
      },
      // getQueryTaxpayer
      getQueryTaxpayer: function (direction) {
        const modul = this;
        let taxnumberInput = "";
        if (direction && direction === "from") {
          taxnumberInput = modul.data.from_taxnumber;
        } else if (direction && direction === "to") {
          taxnumberInput = modul.data.to_taxnumber;
        } else if (!direction || direction === "") {
          taxnumberInput = modul.data.taxnumber;
        }
        if (!taxnumberInput) {
          modul.AlertInPage.msg = "businesspartner.taxPayerErrorEmpty";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        let arrTaxnumber = taxnumberInput.split("-");
        const taxnumber = arrTaxnumber[0];
        if (taxnumber && taxnumber.length !== 8) {

          modul.AlertInPage.msg = "businesspartner.taxPayerErrorFormat";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        const data = {};
        data.taxNumber = taxnumber;
        modul.AlertInPage.msg = "form.in_progress";
        modul.AlertInPage.type = "warning";
        Api.navGetDataByTaxnumber({data: data, id_company: modul.state.id_company}).then(function (res) {
          console.log(res);
          if (res && res.result && res.data) {
//            modul.data = res.data;
            console.log(res.data)

            const data = Object.assign({}, res.data);

            if (direction && direction === "from") {
              const moduldata = Object.assign({}, modul.data);
              moduldata.from_building = Helper.String(data.building); //
              moduldata.from_businesspartnername = Helper.String(data.name); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.from_businesspartnernameany = Helper.String(data.nameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.from_city = Helper.String(data.city); // CSETÉNY"
              moduldata.from_county = Helper.String(data.county); //
              moduldata.from_door = Helper.String(data.door); //
              moduldata.from_email_def = Helper.String(data.email_def); //
              moduldata.from_floor = Helper.String(data.floor); //
              moduldata.from_house_number = Helper.String(data.house_number); // 39"
//                            moduldata.id = Helper.String(data.id) ; //
              moduldata.from_lot_number = Helper.String(data.lot_number); //
              moduldata.from_nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
              moduldata.from_phone_def = Helper.String(data.phone_def); //
              moduldata.from_public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
              moduldata.from_staircase = Helper.String(data.staircase); //
              moduldata.from_zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            } else if (direction && direction === "to") {
              const moduldata = Object.assign({}, modul.data);
              moduldata.to_building = Helper.String(data.building); //
              moduldata.to_businesspartnername = Helper.String(data.name); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.to_businesspartnernameany = Helper.String(data.nameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.to_city = Helper.String(data.city); // CSETÉNY"
              moduldata.to_county = Helper.String(data.county); //
              moduldata.to_door = Helper.String(data.door); //
              moduldata.to_email_def = Helper.String(data.email_def); //
              moduldata.to_floor = Helper.String(data.floor); //
              moduldata.to_house_number = Helper.String(data.house_number); // 39"
//                            moduldata.id = Helper.String(data.id) ; //
              moduldata.to_lot_number = Helper.String(data.lot_number); //
              moduldata.to_nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
              moduldata.to_phone_def = Helper.String(data.phone_def); //
              moduldata.to_public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
              moduldata.to_staircase = Helper.String(data.staircase); //
              moduldata.to_zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            } else if (!direction || direction === "") {
              const moduldata = Object.assign({}, modul.data);
              moduldata.building = Helper.String(data.building); //
              moduldata.businesspartnername = Helper.String(data.name); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.businesspartnernameany = Helper.String(data.nameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.city = Helper.String(data.city); // CSETÉNY"
              moduldata.county = Helper.String(data.county); //
              moduldata.door = Helper.String(data.door); //
              moduldata.email_def = Helper.String(data.email_def); //
              moduldata.floor = Helper.String(data.floor); //
              moduldata.house_number = Helper.String(data.house_number); // 39"
//                            moduldata.id = Helper.String(data.id) ; //
              moduldata.lot_number = Helper.String(data.lot_number); //
              moduldata.nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
              moduldata.phone_def = Helper.String(data.phone_def); //
              moduldata.public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
              moduldata.staircase = Helper.String(data.staircase); //
              moduldata.zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            }

            modul.AlertInPage.msg = "form.succes";
            modul.AlertInPage.type = "success";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(modul.AlertInPage.delay));

          }
        }, function (e) {
          modul.AlertInPage.msg = "form.error";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(modul.AlertInPage.delay));
        });
      },
      displayfn_from_taxnumber: function (value) {
        const modul = this;
        return Helper.displayfn_from_taxnumber(value);
      }

    },
    components: {
//      Addresses,
//      Contacts,
      InputText,
      LeftMenu,
      HeaderSearch,
      HeaderCompanySelector,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
      AlertInPage,
      BarcodeGenerator,
      DataCheckerErrorDisplayer,
      MenuToggle
    },
  };
</script>








